import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=e4fe4ac6&scoped=true"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"
import style0 from "./Btn.vue?vue&type=style&index=0&id=e4fe4ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fe4ac6",
  null
  
)

export default component.exports